import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Input,
  Tooltip,
  Image,
  Select,
  DatePicker,
  Tag,
  Space,
  Modal,
} from "antd";
import React, { useState, useEffect, useContext } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import { useNavigate, useLocation } from "react-router";
import apiPath from "../../constants/apiPath";
import ShowTotal from "../../components/ShowTotal";
import lang from "../../helper/lang";
import moment from "moment";
import ViewAPost from "./ViewAPost";
import { ExclamationCircleOutlined, UndoOutlined } from "@ant-design/icons";
import FilterBar, { FilterBarFilters } from "../../components/FilterBar";
import confirm from "antd/lib/modal/confirm";
import { AuthContext } from "../../context/AuthContext";
import { USERTYPE } from "../../constants/conts";

const Search = Input.Search;
const { Option } = Select;
const { RangePicker } = DatePicker;

function Index() {
  const sectionName = lang("Post");

  const location = useLocation();
  const [postModal, setPostModal] = useState(false);
  const [postId, setPostId] = useState("");
  const [searchText, setSearchText] = useState("");
  const [reportStatus, setReportStatus] = useState("");
  const navigate = useNavigate();
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [postCategories, setPostCategories] = useState([]);
  const [selected, setSelected] = useState();
  // const [visible, setVisible] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isReviewing, setIsReviewing] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState({
    id: null,
    status: null,
  });

  const [filters, setFilters] = useState({
    status: null,
    category: null,
    isReviewed: null,
    postId: null,
  });
  const [showFilters, setShowFilters] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);

  const view = (id) => {
    navigate(`/user/customer/view/${id}`);
  };

  const handleReviewMarked = (id) => {
    request({
      url: `${apiPath.reviewPost}/${id}`,
      method: "PUT",
      data: {
        isReviewed: true,
      },
      onSuccess: (data) => {
        ShowToast(data?.message, Severty.SUCCESS);
        fetchData(pagination, filters);
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
      },
    });
  };

  const columns = [
    {
      title: "Post Id",
      dataIndex: "postId",
      key: "postId",
      render: (_, { postId }) => {
        return postId;
      },
    },
    {
      title: "User Name",
      dataIndex: "userDetails",
      key: "userDetails.name",
      render: (_, { userDetails }) => {
        return (
          <div className="main-new-image-and-text-oki9profile">
            {userDetails?.avatar ? (
              <Image className="image-index-radius" src={userDetails?.avatar} />
            ) : (
              <span className="image-fallback">
                {userDetails?.name
                  ? userDetails?.name.charAt(0).toUpperCase()
                  : "N/A"}
              </span>
            )}
            <a className="cap avatar-text column-avatar-text">
              {userDetails ? userDetails.name : "-"}
            </a>
          </div>
        );
      },
    },
    {
      title: "Visibility",
      dataIndex: "visibility",
      key: "visibility",
      render: (_, { visibility }) => {
        return visibility;
      },
    },
    {
      title: "Post Caption",
      dataIndex: "caption",
      key: "caption",
      render: (_, { caption }) => {
        return <span className="your-caption-class">{caption || "-"}</span>;
      },
    },
    {
      title: `${lang("Post Type")}`,
      key: "mediaType",
      dataIndex: "mediaType",
      render: (mediaType) => mediaType,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_, { status, _id }) => {
        let color =
          status === "active"
            ? "green"
            : status === "suspended"
              ? "yellow"
              : "red";
        return (
          <a>
            <Tag
              onClick={() => handleOpenStatus(_id, status)}
              color={color}
              key={status}
            >
              {status === "active"
                ? "Active"
                : status === "suspended"
                  ? "Suspended"
                  : "Flagged"}
            </Tag>
          </a>
        );
      },
    },
    {
      title: "Total Comment",
      dataIndex: "totalComments",
      key: "totalComments",
      sorter: (a, b) => {
        const commentA = a.totalComments || 0;
        const commentB = b.totalComments || 0;
        return commentA - commentB;
      },
      render: (_, { totalComments }) => {
        return totalComments || "0";
      },
    },
    {
      title: "Total like",
      dataIndex: "totalLike",
      key: "totalLike",
      sorter: (a, b) => {
        const likeA = a.totalLike || 0;
        const likeB = b.totalLike || 0;
        return likeA - likeB;
      },
      render: (_, { totalLike }) => {
        if (!totalLike) return "0";
        return totalLike >= 1000
          ? `${(totalLike / 1000).toFixed(1)}K`
          : totalLike;
      },
    },
    {
      title: "Post At",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: (a, b) => {
        const dateA = moment(a.createdAt);
        const dateB = moment(b.createdAt);
        return dateA.isBefore(dateB) ? -1 : dateA.isAfter(dateB) ? 1 : 0;
      },
      render: (_, { createdAt }) => {
        return moment(createdAt).format("DD-MM-YYYY, HH:mm a") || "-";
      },
    },
    {
      title: `Action`,

      render: (_, record) => {
        return (
          <>
            <div className="main-new-jh-tool">
              <Tooltip
                title={`${lang("View")} ` + sectionName}
                color={"purple"}
                key={"viewtransaction"}
              >
                <Button
                  onClick={() => {
                    setPostId(record?._id);
                    setPostModal(true);
                  }}
                >
                  <i className="fa fa-light fa-eye"></i>
                </Button>
              </Tooltip>

              <Tooltip
                title={
                  isDeletePermissionGranted
                    ? `Delete Post `
                    : "You have not permission"
                }
                color={"purple"}
                key={"deletePost"}
              >
                <Button
                  onClick={() => handleDelete(record._id)}
                  disabled={!isDeletePermissionGranted}
                >
                  <i className="fa fa-light fa-trash"></i>{" "}
                </Button>
              </Tooltip>

              {isReviewing && (
                <Tooltip
                  title={`Review Marked Post `}
                  color={"purple"}
                  key={"markedPost"}
                >
                  <Button onClick={() => handleReviewMarked(record._id)}>
                    <i className="fa fa-solid fa-clipboard-check"></i>{" "}
                  </Button>
                </Tooltip>
              )}
            </div>
          </>
        );
      },
    },
  ];

  const fetchData = (
    pagination,
    filters,
    sorter = { columnKey: "", order: "" },
  ) => {
    const params = new URLSearchParams();
    if (filters.status) {
      params.append("status", filters.status);
    }
    if (debouncedSearchText) {
      params.append("search", debouncedSearchText);
    }
    if (filters.isReviewed !== null) {
      params.append("isReviewed", filters.isReviewed);
    }
    if (startDate) {
      params.append("startDate", startDate);
    }
    if (endDate) {
      params.append("endDate", endDate);
    }
    if (postId) {
      params.append("postId", filters.postId);
    }
    // 📄 Pagination
    params.append("page", pagination.current);
    params.append("limit", pagination.pageSize);
    request({
      url: `${apiPath.listPosts}?${params.toString()}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.data);
        setPagination(() => ({
          current: pagination.current,
          total: data.data.total,
          pageSize: data.data.limit,
        }));
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters, sorter) => {
    console.log(sorter);
    fetchData(pagination, filters, sorter);
  };

  const handleFilterChange = (filterName, value) => {
    setFilters((prev) => ({ ...prev, [filterName]: value }));
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  const resetData = () => {
    setSearchText("");
    setStartDate("");
    setEndDate("");
    setFilters({
      status: null,
      category: null,
    });
    setIsReviewing(false);
    setRefresh((prev) => !prev);
  };

  const handleChangeDate = (e) => {
    setPagination({ current: 1, pageSize: pagination.pageSize });
    if (e != null) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    } else {
      setStartDate();
      setEndDate();
    }
  };

  const handleDelete = (id) => {
    setTimeout(() => {
      confirm({
        maskClosable: true,
        icon: <ExclamationCircleOutlined />,
        className: "tab_modal",
        cancelButtonProps: { color: "red" },
        content: (
          <p
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Are you sure you want to delete this post permanently ?
          </p>
        ),
        onOk() {
          request({
            url: `${apiPath.deletePost}/${id}`,
            method: "DELETE",
            data: {},
            onSuccess: (data) => {
              fetchData(pagination, filters);
              ShowToast(
                `${data.message || "Status Changed Successfully"}`,
                Severty.SUCCESS,
              );
            },
            onError: (error) => {
              const message = error.response.data.message;
              setLoading(false);
              ShowToast(message, Severty.ERROR);
            },
          });
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  const handleOpenStatus = (id, currentStatus) => {
    setSelectedPost({ id, status: currentStatus });
    setStatusModalOpen(true);
  };

  const handleStatus = (id, status) => {
    request({
      url: `${apiPath.changePostStatus}/${id}`,
      method: "PUT",
      data: { status },
      onSuccess: (data) => {
        setStatusModalOpen(false);
        fetchData(pagination, filters);
        ShowToast(
          `${data.message || "Status Changed Successfully"}`,
          Severty.SUCCESS,
        );
      },
    });
  };

  const handleReviewQueue = () => {
    setFilters((prev) => ({
      ...prev,
      status: "flagged",
      isReviewed: false,
    }));

    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));
  };

  const handleReviewedPosts = () => {
    setFilters((prev) => ({
      ...prev,
      status: "flagged",
      isReviewed: true,
    }));

    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));
  };

  // Open View Post modal if navigated from GlobalSearch with a postId
  useEffect(() => {
    if (location.state && location.state.postId) {
      setPostId(location.state.postId);
      setSearchText(location.state.postId);
      setPostModal(true);
    }
  }, [location.state]);

  // ------------ Module Permissions ------------

  const { userProfile, userPermission } = useContext(AuthContext);
  const isSuperAdmin = userProfile?.role === USERTYPE.SUPER_ADMIN;

  const isUpdatePermissionGranted =
    isSuperAdmin ||
    (userPermission?.POST_MANAGER?.enabled === true &&
      userPermission.POST_MANAGER.permissions.update === true);
  const isDeletePermissionGranted =
    isSuperAdmin ||
    (userPermission?.POST_MANAGER?.enabled === true &&
      userPermission.POST_MANAGER.permissions.delete === true);

  useEffect(() => {
    setLoading(true);
    fetchData(pagination, filters);
  }, [filters, refresh, debouncedSearchText, startDate, endDate, reportStatus]);

  return (
    <>
      <div className="tabled">
        <ViewAPost
          isOpen={postModal}
          setIsOpen={setPostModal}
          postId={postId}
          setLoading={setLoading}
        />
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={sectionName + ` ${lang("Manager")}`}
              extra={
                <FilterBar
                  showFilters={showFilters}
                  onToggle={() => setShowFilters((v) => !v)}
                  searchContent={
                    <Search
                      size="large"
                      onChange={onSearch}
                      value={searchText}
                      onPressEnter={onSearch}
                      allowClear
                      placeholder={`${lang("Search")} ${lang(
                        "By User Name or Mobile Number",
                      )}`}
                    />
                  }
                  rightContent={
                    <>
                      <Button
                        onClick={() => {
                          handleReviewQueue();
                          setIsReviewing(true);
                        }}
                        type="primary"
                      >
                        Review Queue
                      </Button>
                      <Button
                        onClick={() => {
                          handleReviewedPosts();
                          setIsReviewing(false);
                        }}
                        type="primary"
                      >
                        Reviewed Posts
                      </Button>
                    </>
                  }
                />
              }
            >
              {showFilters && (
                <FilterBarFilters>
                  <Select
                    placeholder="Status"
                    value={filters.status}
                    onChange={(value) => handleFilterChange("status", value)}
                    allowClear
                  >
                    <Option value="active">Active</Option>
                    <Option value="suspended">Suspended</Option>
                    <Option value="flagged">Flagged</Option>
                  </Select>

                  <RangePicker
                    disabledDate={(current) =>
                      current && current.isAfter(moment().endOf("day"))
                    }
                    onChange={handleChangeDate}
                    value={
                      startDate && endDate
                        ? [moment(startDate), moment(endDate)]
                        : null
                    }
                  />
                  <Button
                    onClick={() => resetData()}
                    type="primary"
                    icon={<UndoOutlined />}
                  >
                    Reset
                  </Button>
                </FilterBarFilters>
              )}
              <h4 className="text-right mb-1">
                {pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}
              </h4>
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Status Update Modal */}
      <Modal
        open={statusModalOpen}
        footer={null}
        centered
        closable
        onCancel={() => setStatusModalOpen(false)}
      >
        <div style={{ textAlign: "center" }}>
          <p style={{ fontSize: 22, fontWeight: "bold", marginBottom: 20 }}>
            Change Post Status
          </p>

          <Space size="middle">
            {selectedPost.status !== "active" && (
              <Button
                type="primary"
                style={{ background: "#52c41a", borderColor: "#52c41a" }}
                onClick={() => handleStatus(selectedPost.id, "active")}
              >
                Active
              </Button>
            )}

            {selectedPost.status !== "suspended" && (
              <Button
                type="primary"
                style={{ background: "#faad14", borderColor: "#faad14" }}
                onClick={() => handleStatus(selectedPost.id, "suspended")}
              >
                Suspend
              </Button>
            )}

            {selectedPost.status !== "flagged" && (
              <Button
                type="primary"
                danger
                onClick={() => handleStatus(selectedPost.id, "flagged")}
              >
                Flagged
              </Button>
            )}
          </Space>
        </div>
      </Modal>
    </>
  );
}

export default Index;
